import React, { useEffect, useRef, useState } from "react";
import HorizontalStepper from "../../stepper/stepper";
import CoapInfo from "../coapplicant/coapInfo";
import Axios from "axios";
import IdInfo from "../coapplicant/idInfo";
import ContactInfo from "../coapplicant/contactInfo";
import ResidenceInfo from "../coapplicant/residenceInfo";
import EmploymentInfo from "../coapplicant/employmentInfo";
import { errors } from "../modules/formsBody";
import { Button } from "@material-ui/core";
import { validateForm } from "../coapplicant/validateForm";
import CustomizedSnackbars from "../../alerts/CustomizedSnackbars";
import Confirmation from "../coapplicant/confirmation";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { LoadingFullScreen } from "../helpers/assets";
import { AppFillSkeleton } from "../../assets/skeletons";
import { NotFoundGeneral } from "../../assets/notFound";
import CreateAppBar from "../helpers/appBar";
import BottomMenu from "../../footer/bottomMenu";
import Cookies from "universal-cookie";
import { OnyxHeader } from "../../header/onyxHeader";

const cookies = new Cookies();
const token = cookies.get('token');

let publicMode = false;
let title = "Fill Co-Applicant";
let subTitle = "Fill up the required information and click Continue to submit it to the Credit Department for verification";


//Set config for public use
if (token == undefined) {
    publicMode = true;
    title = "Fill Co-Applicant Details";
    subTitle = "Fill up the required information and click Continue to submit";
}

const CoAppFill = (props) => {
    //Main states
    const [coApplicant, setCoapplicant] = useState(false);
    const [coapInfo, setCoapInfo] = useState(null);
    const [idInfo, setidInfo] = useState(null);
    const [contactInfo, setContactInfo] = useState(null);
    const [residenceInfo, setResidenceInfo] = useState(null);
    const [employmentInfo, setEmploymentInfo] = useState(null);

    //Secondary States
    const [loading, setLoading] = useState(true);
    const [loadingError, setLoadingError] = useState(false);
    const [formError, setFormError] = useState(errors);
    const [alert, setAlert] = useState(false);
    const [confirmation, setConfirmation] = useState(false);
    const [modalLoading, setModalLoading] = useState(false);

    //History
    const history = useHistory();

    //Refs
    const applicantInfoRef = useRef();
    const idInfoRef = useRef();
    const contactInformationRef = useRef();
    const residenceRef = useRef();
    const employmentRef = useRef();

    //Handlers
    const handleForm = (name, data) => {
        name === 'coapInfo' && setCoapInfo(data);
        name === 'idInfo' && setidInfo(data);
        name === 'contactInfo' && setContactInfo({ ...contactInfo, ...data });
        name === 'residenceInfo' && setResidenceInfo(data);
        name === 'employmentInfo' && setEmploymentInfo(data);
    }

    //Validate Form and send
    const validateFormPriorToSending = () => {
        const validatedForm = validateForm(coapInfo, idInfo, contactInfo, residenceInfo, employmentInfo);
        !validatedForm.valid && setFormError({ ...formError, [validatedForm.target]: { error: true, message: validatedForm.errorMessage } });
        !validatedForm.valid && scrollToError(validatedForm.reference, validatedForm.errorMessage);
        validatedForm.valid && sendForm();
    }
    const sendForm = () => {
        setModalLoading(true);
        Axios.post(
            `${props.host}/application/fillCoap`,
            { coapInfo, idInfo, contactInfo, residenceInfo, employmentInfo },
            { headers: { Authorization: `Bearer ${props.token}` } }
        )
            .then(res => setConfirmation(true), setModalLoading(false), sendAppByEmail())
            .catch(error => error && setAlert({ message: error.response.data, severity: 'error' }), setModalLoading(false));
    }
    const sendAppByEmail = () => {
        setConfirmation({ show: true });
        Axios.get(
            `${props.host}/application/createAppPdf&app_id=${props.match.params.app_id}&send_by_email=true`,
            { headers: { Authorization: `Bearer ${props.token}` } })
            .then((res) => {
            })
            .catch((error) => {
                if (error) {
                    let alertData = { ...alert };
                    alertData.show = true;
                    alertData.severity = 'error';
                    alertData.message = error.response.data;
                    setLoading(false);
                    setAlert(alertData);
                }
            });
    }

    //Scroll to error
    const scrollToError = (reference, message) => {
        const scroll = reference + '.current.scrollIntoView({ behavior: "smooth" })';
        if (message === undefined) message = 'There are errors in the form';
        else message = message;
        eval(scroll);
        setAlert({ message: message, severity: 'error' });
    }

    //Onload
    useEffect(() => {
        //Validate that we don't have coap information in the application already
        Axios.get(
            `${props.host}/application/validateCoapIsFilled?app_id=${props.match.params.app_id}`,
            { headers: { Authorization: `Bearer ${props.token}` } }
        )
            .then(loadCoapData())
            .catch(error => error && setLoadingError(error.response.data));
    }, []);

    const loadCoapData = () => {
        //Loading Co-applicant information and options
        Axios.get(
            `${props.host}/application/view?app_id=${props.match.params.app_id}&coapplicant`,
            { headers: { Authorization: `Bearer ${props.token}` } }
        )
            .then(res => {
                setCoapplicant(res.data);
                setContactInfo({ ...contactInfo, ...{ email: res.data.email } });
            })
            .catch(error => error && setLoadingError(error.response.data));
    }

    //Hide Loader when finished
    useEffect(() => {
        coApplicant && setLoading(false);
        loadingError && setLoading(false);
    }, [coApplicant, loadingError]);

    return (
        <>
            {publicMode &&
                <OnyxHeader />
            }
            <CreateAppBar title={title} back={() => history.goBack()} />
            {loading &&
                <AppFillSkeleton />
            }
            {loadingError &&
                <NotFoundGeneral message={loadingError} />
            }
            {modalLoading &&
                <LoadingFullScreen />
            }
            {coApplicant && !loadingError &&
                <div style={{ margin: '1rem' }}>
                    <p className="mt-3">{subTitle}</p>
                    {
                        <>
                            {publicMode && <HorizontalStepper activeStep={1} steps={['Let us Know You', 'Send Final Details']} />}
                            {!publicMode && <HorizontalStepper activeStep={1} steps={['Request credit Inquiry', 'Send Application Details', 'Request Paperwork']} />}
                        </>

                    }

                    <h4 ref={applicantInfoRef} className="mt-5">Applicant Information</h4>
                    <CoapInfo data={coApplicant} handleForm={handleForm} formError={formError} setFormError={setFormError} />

                    <h4 ref={idInfoRef} className="mt-5">ID Information</h4>
                    <IdInfo formOptions={coApplicant.options} handleForm={handleForm} formError={formError} setFormError={setFormError} />

                    <h4 ref={contactInformationRef} className="mt-5" >Contact Info</h4>
                    <ContactInfo formOptions={coApplicant.options} handleForm={handleForm} formError={formError} setFormError={setFormError} />

                    <h4 ref={residenceRef} className="mt-5">Residence</h4>
                    <ResidenceInfo formOptions={coApplicant.options} handleForm={handleForm} formError={formError} setFormError={setFormError} />

                    <h4 ref={employmentRef} className="mt-5">Employment</h4>
                    <EmploymentInfo formOptions={coApplicant.options} handleForm={handleForm} formError={formError} setFormError={setFormError} />

                    <Button onClick={validateFormPriorToSending} className="mt-3 mb-3" variant="contained" color="primary">Continue</Button>
                </div>
            }
            {alert &&
                <CustomizedSnackbars severity={alert.severity} message={alert.message} hideAlert={() => setAlert(false)} />
            }
            {confirmation &&
                <Confirmation show={true} onClickContinue={publicMode ? () => window.location.href = 'https://onyxwatertreatment.com' : () => history.push('/app_details/' + props.match.params.app_id)}>

                    {publicMode &&
                        <>
                            <h2 style={{ color: 'green' }}>Application Sent</h2>
                            Thanks for sending your credit request!  <br /><br />
                            We’ve got it and our team is already reviewing it. We’ll get back to you very soon with an update.<br /><br />
                            Your Application request number is <b>{props.match.params.app_id}</b>.<br /><br />
                            Talk to you soon! 😊<br /><br />
                        </>
                    }
                    {!publicMode &&
                        <>
                            <h2 style={{ color: 'green' }}>Application Sent</h2>
                            The Application was sent to the Applications department. They will now submit it to our finance agencies.<br /><br />
                            Please contact Apps department to let them know you have completed this step.<br /><br />
                            For future reference the App assigned will be <b>{props.match.params.app_id}</b>.<br /><br />
                        </>
                    }

                </Confirmation>}

            {!publicMode && <BottomMenu showOnDesktop={true} />}

        </>
    )
}
export default CoAppFill;